export default "__VITE_ASSET__DiMT4nMh__"